export enum SimulationState {
    Ready = "ready",
    Running = "running",
    Completed = "completed",
    Failed = "failed",
    Paused = "paused",
    InLoop = "in-loop",
}

export enum SimulationDataState 
{
    None = "none",
    Received = "received",
    Receiving = "receiving",
    Failed = "failed",
}

export enum RenderState {
    None = "none",
    Rendering = "rendering",
    Rendered = "rendered",
    Failed = "failed",
}
